import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  showStatsPanel: false,
  isStatsPanelFixed: false,
};

// ----------------------------------------------------------------------

const slice = createSlice({
  name: 'uiConfig',
  initialState,
  reducers: {
    toggleStatsPanel(state, action) {
      state.showStatsPanel = action.payload !== undefined ? action.payload : !state.showStatsPanel;
    },
    toggleStatsPanelFixed(state, action) {
      state.isStatsPanelFixed = action.payload !== undefined ? action.payload : !state.isStatsPanelFixed;

      if (state.isStatsPanelFixed) {
        state.showStatsPanel = true;
      }
    },
  },
});

export const { toggleStatsPanel, toggleStatsPanelFixed } = slice.actions;

export default slice.reducer;
